var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleRifleHalo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.667 24.312L114.316 24.4815H106.037V23.4675L103.081 22.2855C103.081 22.2855 85.9402 22.5195 85.0192 22.608C84.0982 22.6965 83.4847 24.0585 83.4847 24.0585L65.6617 24.228L62.2837 18.7125H58.3132V17.0055H61.9027L63.0847 16.4565L64.2247 17.0055L65.1112 16.4565L66.5182 13.416L63.5902 13.0785L62.7292 13.839L61.2247 11.8965H59.5357V12.783L58.5922 13.1625L57.4237 12.7395V11.895H54.9322V12.867L52.3417 13.1625L51.5527 13.416L50.4547 12.867H47.3722L46.8232 13.5435V16.1475L47.4562 17.049H49.7797L50.7937 16.626H51.5542V18.7125L39.4477 18.7365C39.4477 18.7365 34.2487 18.843 29.5927 19.5825C24.9382 20.322 22.0747 27.354 22.0747 27.354H19.1182L17.9362 26.847H1.71973V30.0435H17.5432L19.1197 29.55L20.8087 29.466L19.1197 32.5065L20.8087 35.406L20.9782 36.8145L22.8367 40.0245L23.7937 38.928C23.7937 38.928 44.2072 40.701 46.8247 40.707C49.4437 40.713 51.3697 39.2565 51.3697 39.2565L54.5407 37.152L55.6102 36.3915L57.2992 36.8145H62.3677C62.3677 36.8145 63.9262 38.9265 64.5112 39.429C65.0962 39.933 66.4147 39.84 66.4147 39.84L71.9692 39.996C71.9692 39.996 73.2637 41.628 73.5637 42.459C73.8622 43.29 73.3492 44.4165 73.3492 44.4165C73.3492 44.4165 75.1477 46.8825 75.2917 47.289C75.4357 47.6955 75.2542 49.068 75.2542 49.068L75.7987 50.0775L77.2357 50.175L84.7522 48.3885C84.7522 48.3885 79.5157 39.7725 78.9232 38.9295C78.3322 38.0865 78.7912 36.7575 79.1767 35.718C79.5622 34.68 81.4567 35.0415 81.4567 35.0415L84.2437 35.718C84.2437 35.718 86.9437 39.9915 87.3112 40.626C87.6787 41.2605 89.0887 41.919 89.0887 41.919L91.7182 41.9055L92.6617 42.7095C92.6617 42.7095 108.569 42.8115 109.382 42.651C110.195 42.4905 110.653 42.0525 110.653 42.0525H114.313C114.313 42.5595 116.512 42.651 116.512 42.651L118.114 41.46V24.9885L115.664 24.312H115.667ZM54.2587 24.0585L53.0767 23.9745L49.5292 24.9885H44.7427V25.4115H29.5942C29.5942 25.4115 29.4247 22.7925 31.3687 22.0335C33.3112 21.273 44.0602 21.357 44.0602 21.357L45.3397 22.0335L53.3302 21.9495L54.2587 22.9635V24.0615V24.0585ZM69.3067 38.361H66.1687C66.1687 38.361 64.8172 38.079 64.8172 36.5595C64.8172 35.04 65.9992 34.758 65.9992 34.758H69.5467L69.3892 35.7855C69.4987 36.042 70.0657 36.276 70.0657 36.672C70.0657 37.995 69.3052 38.361 69.3052 38.361H69.3067Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0815 34.716H75.4595C75.4595 34.716 76.4735 34.7865 76.811 36.054C77.1485 37.3215 76.136 37.701 75.755 37.8705C75.3755 38.04 70.9775 39.798 70.9775 39.798",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0234 32.0834V33.2234H82.4989C82.4989 33.2234 84.6949 33.1949 86.1034 35.0534C87.5119 36.9119 90.1054 41.9039 90.1054 41.9039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7778 34.068H100.576C100.576 34.068 101.758 34.0395 102.152 34.716C102.547 35.391 103.039 36.264 103.039 36.264C103.039 36.264 103.334 36.8535 102.827 37.2555C102.32 37.6575 101.729 37.0455 101.645 36.993C101.561 36.9405 101.308 36.666 100.378 36.993C99.4478 37.32 93.9578 38.8395 93.9578 38.8395C93.9578 38.8395 93.0713 39.1065 92.5223 38.319C91.9733 37.5315 91.3403 36.4755 91.3403 36.4755C91.3403 36.4755 90.8753 35.841 90.4538 35.757C90.0308 35.673 89.7053 35.3205 89.7143 34.8915C89.7248 34.3875 90.1058 34.068 90.7778 34.068V34.068Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.264 32.8439H106.675C106.242 32.8439 105.891 33.1952 105.891 33.6284C105.891 34.0617 106.242 34.4129 106.675 34.4129H112.264C112.697 34.4129 113.049 34.0617 113.049 33.6284C113.049 33.1952 112.697 32.8439 112.264 32.8439Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.188 31.8299H110.387L109.796 31.1115H19.9941",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8945 29.4225L21.739 28.071H114.189",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3428 24.0165V25.7625L55.3568 26.775H114.4",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3709 26.7749L83.5684 25.3964V24.4379H100.8L101.927 25.0304V26.7749",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.123 24.4379V26.7749",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.854 29.091H110.925L108.89 30.2745L106.854 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1543 29.091H102.225L100.19 30.2745L98.1543 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4531 29.091H93.5256L91.4901 30.2745L89.4531 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7532 29.091H84.8257L82.7902 30.2745L80.7532 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0527 29.091H76.1252L74.0882 30.2745L72.0527 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3535 29.091H67.426L65.389 30.2745L63.3535 29.091Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0757 30.195H59.0032L61.0387 29.0115L63.0757 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7756 30.195H67.7031L69.7386 29.0115L71.7756 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4756 30.195H76.4031L78.4386 29.0115L80.4756 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.176 30.195H85.1035L87.1405 29.0115L89.176 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8752 30.195H93.8027L95.8397 29.0115L97.8752 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.576 30.195H102.505L104.54 29.0115L106.576 30.195Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3906 40.146C72.3906 40.146 76.3971 38.5455 76.8786 38.6295C77.3601 38.7135 79.0071 38.8845 79.0071 38.8845",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.915 24.438V26.55",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9941 49.644C79.9941 49.644 80.9226 47.8365 81.0906 47.781C81.2586 47.7255 83.8731 46.743 83.8731 46.743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 28.071V31.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9775 28.071V31.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6094 28.071V31.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2432 28.071V31.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8762 28.071V31.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5117 26.379L33.1312 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0283 26.379L35.6478 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5439 26.379L38.1634 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0615 26.379L40.681 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5762 26.379L43.1957 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0938 26.379L45.7133 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6104 26.379L48.2299 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1262 26.379L50.7457 27.2235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7949 26.775H28.5804C28.5804 26.775 27.7074 22.9545 29.8749 21.3105C32.0424 19.6665 35.6469 20.1735 35.6469 20.1735L59.6634 20.343C59.6634 20.343 61.3104 20.259 61.3104 21.6525C61.3104 22.962 59.6529 22.9725 59.6529 22.9725L55.6929 22.962V26.7765",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.389 34.716H54.625",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2754 24.945H52.8229L54.6244 28.071V37.1085",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3425 35.73L46.0085 32.844",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2836 35.3625L47.6106 36.4755C47.6106 36.4755 45.9246 36.855 45.0936 36.798C44.2641 36.741 26.8072 35.7285 26.8072 35.7285L23.8792 38.883",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6094 37.6995V39.051",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0459 37.8615V39.213",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4814 38.0235V39.375",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.917 38.1855V39.537",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3545 38.3024V39.6539",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.79 38.4465V39.798",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2256 38.538V39.8895",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6611 38.67V40.0215",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0977 38.7599V40.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5332 38.8605V40.212",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9688 38.9925V40.344",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4053 39.1215V40.473",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.957 39.2296V40.5811",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4302 46.7955C79.7417 46.7955 79.9942 46.543 79.9942 46.2315C79.9942 45.92 79.7417 45.6675 79.4302 45.6675C79.1187 45.6675 78.8662 45.92 78.8662 46.2315C78.8662 46.543 79.1187 46.7955 79.4302 46.7955Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.365 35.9055C101.455 35.9055 101.527 35.833 101.527 35.7435C101.527 35.654 101.455 35.5815 101.365 35.5815C101.276 35.5815 101.203 35.654 101.203 35.7435C101.203 35.833 101.276 35.9055 101.365 35.9055Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8036 35.322C91.8931 35.322 91.9656 35.2495 91.9656 35.16C91.9656 35.0705 91.8931 34.998 91.8036 34.998C91.7141 34.998 91.6416 35.0705 91.6416 35.16C91.6416 35.2495 91.7141 35.322 91.8036 35.322Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6991 21.78C59.7886 21.78 59.8611 21.7075 59.8611 21.618C59.8611 21.5285 59.7886 21.456 59.6991 21.456C59.6096 21.456 59.5371 21.5285 59.5371 21.618C59.5371 21.7075 59.6096 21.78 59.6991 21.78Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3778 15.3645C53.4673 15.3645 53.5398 15.2919 53.5398 15.2025C53.5398 15.113 53.4673 15.0405 53.3778 15.0405C53.2884 15.0405 53.2158 15.113 53.2158 15.2025C53.2158 15.2919 53.2884 15.3645 53.3778 15.3645Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9568 37.179C44.2326 37.179 44.4563 36.9554 44.4563 36.6795C44.4563 36.4036 44.2326 36.18 43.9568 36.18C43.6809 36.18 43.4573 36.4036 43.4573 36.6795C43.4573 36.9554 43.6809 37.179 43.9568 37.179Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1743 36.3615C29.4502 36.3615 29.6738 36.1379 29.6738 35.862C29.6738 35.5861 29.4502 35.3625 29.1743 35.3625C28.8984 35.3625 28.6748 35.5861 28.6748 35.862C28.6748 36.1379 28.8984 36.3615 29.1743 36.3615Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0823 15.6465C56.5835 15.6465 56.9898 15.2402 56.9898 14.739C56.9898 14.2378 56.5835 13.8315 56.0823 13.8315C55.5811 13.8315 55.1748 14.2378 55.1748 14.739C55.1748 15.2402 55.5811 15.6465 56.0823 15.6465Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1258 41.145C76.4373 41.145 76.6898 40.8925 76.6898 40.581C76.6898 40.2695 76.4373 40.017 76.1258 40.017C75.8143 40.017 75.5618 40.2695 75.5618 40.581C75.5618 40.8925 75.8143 41.145 76.1258 41.145Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2053 27.3105V29.5065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6272 26.8035V30",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2197 27.2234V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0801 27.2234V30.1949",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01367 27.2235V30",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47754 28.4025H12.3905",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8376 29.0115H32.6916C32.3652 29.0115 32.1006 29.2761 32.1006 29.6025C32.1006 29.9289 32.3652 30.1935 32.6916 30.1935H51.8376C52.164 30.1935 52.4286 29.9289 52.4286 29.6025C52.4286 29.2761 52.164 29.0115 51.8376 29.0115Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80396 26.8035H18.445L19.2055 27.3105H22.162C22.162 27.3105 25.1185 20.637 29.68 19.539C34.2415 18.441 38.4175 18.6945 38.4175 18.6945L62.368 18.669L65.746 24.1845L83.8224 24.1005C83.8224 24.1005 84.0759 22.5795 85.5114 22.4955C86.9469 22.4115 103.165 22.242 103.165 22.242L106.121 23.424V24.438H114.4L115.751 24.2685L118.201 24.9435V41.415C118.201 41.415 116.849 42.8505 115.835 42.7665C114.821 42.6825 114.4 42.006 114.4 42.006H111.359L109.417 38.5425L106.039 38.4585L92.6934 41.8365L89.3154 41.9205L87.8799 41.4135C87.8799 41.4135 84.754 35.9235 84.3325 35.67C83.911 35.4165 81.5454 34.995 81.5454 34.995C81.5454 34.995 79.9404 34.488 79.2654 35.67C78.5904 36.852 78.6744 38.289 79.6029 39.7245C80.5314 41.16 84.8395 48.3405 84.8395 48.3405L79.9974 49.641C79.9974 49.641 76.984 50.4525 75.886 50.0295C74.788 49.6065 75.7165 48.5085 75.379 47.2425C75.0415 45.975 73.4365 44.37 73.4365 44.37C73.4365 44.37 74.0275 42.5115 73.3525 41.583C72.6775 40.6545 72.7615 39.894 71.326 39.8085C69.8905 39.7245 65.5825 39.8085 65.5825 39.8085C65.5825 39.8085 64.8145 39.7245 64.015 38.88C63.217 38.0355 62.4565 36.768 62.4565 36.768H57.388L56.4595 36.345H55.186L54.7705 37.1055C54.7705 37.1055 50.9695 39.639 49.8715 40.062C48.7735 40.485 47.1685 40.8225 44.296 40.653C41.4235 40.4835 24.1075 38.964 24.1075 38.964L22.9255 39.978L21.067 36.768V35.9235L19.2085 32.46L20.8975 29.4195L19.2925 29.5035L18.448 29.997H1.80396V26.8005V26.8035Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6783 25.368C29.6783 25.368 29.5088 22.749 31.4528 21.99C33.3953 21.2295 44.1443 21.315 44.1443 21.315L45.4238 21.99L53.4143 21.906L54.3428 22.92V24.018L53.1608 23.934L49.6133 24.948H44.8268V25.371H29.6783V25.368Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M110.914 41.214C110.914 41.214 111.233 42.768 108.656 42.768H93.3249C93.3249 42.768 91.93 42.6855 91.804 41.8605",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M114.399 42.0075V36.0525V24.438",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4 36.0525H104.855L103.757 34.152C103.757 34.152 102.871 32.631 100.21 32.589C97.5488 32.547 86.6528 32.589 86.6528 32.589L86.1458 32.082H61.9883L59.4548 33.603L54.5978 33.687L50.2058 32.4615H29.0873V32.082H25.0328C25.0328 32.082 23.6813 32.04 23.1743 32.8845C22.6673 33.729 21.0623 35.925 21.0623 35.925",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6397 18.669V16.5825H50.8807L50.1622 17.0055H47.5432L46.9102 16.5825V13.5L47.4592 12.825H50.5417L51.0487 13.374H51.6397V12.825H55.0192V11.853H57.5107V13.1205H59.0737L59.6227 12.7395V11.853H61.6072V12.6975L62.2837 13.416L63.2962 13.374L63.6772 13.035L66.8017 12.993L65.1967 16.077V16.9215H63.5497L63.1702 16.4145H62.4517L61.9882 16.9635H58.3972V18.669",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0488 13.374V16.104",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6797 13.1205V16.9635",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8164 13.3935V16.4145",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0853 34.7161H71.2948C71.2948 34.7161 72.3928 35.1106 72.3928 36.6301C72.3928 37.9531 71.6323 38.3191 71.6323 38.3191H66.2548C66.2548 38.3191 64.9033 38.0371 64.9033 36.5176C64.9033 34.9981 66.0853 34.7161 66.0853 34.7161Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6328 34.7161L69.2383 35.4766C69.2383 35.4766 69.6883 35.8996 69.9133 36.5191C70.1383 37.1386 69.5758 38.3206 69.5758 38.3206",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleRifleHalo2);
export default __webpack_public_path__ + "static/media/Battle Rifle Halo2.c46b60be41e79a95a3571aa32c7b6236.svg";
export { ForwardRef as ReactComponent };